import axios from 'axios';
import { AUTH_HEADERS, HTTP_STATUS } from '../constants';
import { store } from '../store/index.js';
import { logout } from '../store/slices/authSlice';

class ApiClient {
  constructor() {
    const baseURL = process.env.REACT_APP_MAIN_API_URL;

    const config = {
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    this.instance = axios.create(config);
    this.setupInterceptors();
  }

  setupInterceptors() {
    this.instance.interceptors.request.use(
      (config) => {
        const state = store.getState();
        const token = state.auth.token;

        if (token && config.headers) {
          config.headers.Authorization = `${AUTH_HEADERS.BEARER} ${token}`;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
          store.dispatch(logout());
        }
        return Promise.reject(error);
      }
    );
  }

  get(url, config) {
    return this.instance.get(url, config);
  }

  post(url, data, config) {
    return this.instance.post(url, data, config);
  }

  put(url, data, config) {
    return this.instance.put(url, data, config);
  }

  delete(url, config) {
    return this.instance.delete(url, config);
  }
}

const apiInstance = new ApiClient();

export default apiInstance;
